import { setGoogleDataLayer } from 'Tracking/tracking-api';
import cookies from 'js-cookie';
import sha1 from 'crypto-js/sha1';
import { useAppContext } from 'Context/ReactAppContext';
export const useTrackEvent = () => {
  const { isSeller } = useAppContext();

  const trackEvent = (name: string, payload: TrackPayload = {}) => {
    setGoogleDataLayer({ ...payload, event: name }, isSeller ? 'page_referrer' : 'referrer');
  };

  const trackUniqueEvent = (name: string, payload: TrackPayload = {}) => {
    const cookieName = `${name}_${sha1(JSON.stringify(payload))}`;

    if (cookies.get(cookieName)) {
      return;
    }

    cookies.set(cookieName, 'true', {
      expires: 7,
    });
    return trackEvent(name, payload);
  };

  const trackClickEvent = (name: string, payload: TrackPayload = {}) => {
    trackEvent(name, {
      event_click: null,
    });
    trackEvent(name, {
      event_click: payload,
    });
  };

  return {
    trackClickEvent,
    trackEvent,
    trackUniqueEvent,
  };
};
